export const statusStyles = {
  Success: {
    color: "#20C374",
    backgroundColor: "#e6fbf1",
  },
  Pending: {
    color: "#738DED",
    backgroundColor: "#e3e8fb",
  },
  Fail: {
    color: "#e04f4f",
    backgroundColor: "#ffe2dd",
  },
  PendingUnallowed: {
    color: "#666666",
    backgroundColor: "#f0f0f0",
    circleNumberBackgroundColor: "rgb(102, 102, 102)",
  },
};
